<aside id="sidebar"
	data-drawer-backdrop="false"
	class="fixed md:sticky top-0 left-0 z-50 flex-col flex-shrink-0 w-72 md:w-64 h-[100dvh] font-normal duration-300 flex transition-transform -translate-x-full md:translate-x-0 shadow-2xl md:shadow-none bg-white border-r border-gray-100">
	
    <div class="flex flex-col h-full rounded-r-lg md:rounded-none bg-white">
        <!-- Sidebar Header (Mobile Only) -->
        <div class="flex items-center justify-between px-6 py-8 md:hidden pt-[calc(env(safe-area-inset-top)+2rem)]">
            <app-logo></app-logo>
            <button type="button" (click)="closeDrawer()"
                class="text-gray-400 hover:text-gray-900 bg-gray-50 hover:bg-gray-100 rounded-md p-2 transition-all">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </button>
        </div>

        <div class="flex flex-col flex-1 pt-4 md:pt-8 pb-4 overflow-y-auto no-scrollbar">
			<div class="flex-1 px-4 md:px-6 space-y-4">
				<h5 id="sidebar-label" class="text-[11px] font-bold text-gray-400 uppercase tracking-[0.2em] mb-6 pl-3">
					Menú Principal
				</h5>
				
				<ul class="space-y-2 pb-32 md:pb-10">
					@for (route of options; track route.id) {
						<li>
							@if (route.childs && route.childs.length > 0) {
								<button [attr.aria-controls]="route.dropdown" [attr.data-collapse-toggle]="route.dropdown"
									(click)="route.collapse = !route.collapse" type="button"
									class="flex items-center w-full p-3 text-lg font-bold text-gray-900 tracking-tight transition-all rounded-md group hover:bg-emerald-50 hover:text-[#10B981]"
									routerLinkActive="text-[#10B981] bg-emerald-50"
									#rla="routerLinkActive">

									<div class="w-10 h-10 rounded-md flex items-center justify-center transition-all duration-300 shadow-sm"
										[class.bg-[#10B981]]="rla.isActive || route.collapse"
										[class.text-white]="rla.isActive || route.collapse"
										[class.bg-white]="!rla.isActive && !route.collapse"
										[class.text-gray-400]="!rla.isActive && !route.collapse"
										[class.border]="!rla.isActive && !route.collapse"
										[class.border-gray-100]="!rla.isActive && !route.collapse">
										<ion-icon class="text-xl" [name]="route.icon"></ion-icon>
									</div>

									<ion-label class="flex-1 ml-4 text-left whitespace-nowrap">
										{{ route.name }}
									</ion-label>
									<svg class="w-4 h-4 transition-transform duration-300" [class.rotate-180]="route.collapse" fill="none" stroke="currentColor"
										viewBox="0 0 24 24">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
									</svg>
								</button>
								<ul [class.hidden]="!route.collapse" [id]="route.dropdown" class="py-2 pl-4 space-y-1 border-l-2 border-emerald-50 ml-8 mt-1">
									@for (child of route.childs; track child.name) {
										<li>
											<a (click)="closeDrawer()"
												[routerLink]="child.route"
												routerLinkActive="text-[#10B981] font-bold"
												class="flex items-center p-2.5 text-[15px] font-semibold text-gray-500 transition-all rounded-md hover:text-[#10B981] hover:bg-emerald-50">
												{{ child.name }}
											</a>
										</li>
									}
								</ul>
							} @else {
								<a (click)="closeDrawer()"
									[routerLink]="route.route"
									routerLinkActive="text-[#10B981] bg-emerald-50 shadow-sm"
									#rla="routerLinkActive"
									class="flex items-center p-3 text-lg font-bold text-gray-900 tracking-tight transition-all rounded-md group hover:bg-emerald-50 hover:text-[#10B981]">
									
									<div class="w-10 h-10 rounded-md flex items-center justify-center transition-all duration-300 shadow-sm"
										[class.bg-[#10B981]]="rla.isActive"
										[class.text-white]="rla.isActive"
										[class.bg-white]="!rla.isActive"
										[class.text-gray-400]="!rla.isActive"
										[class.border]="!rla.isActive"
										[class.border-gray-100]="!rla.isActive">
										<ion-icon class="text-xl" [name]="route.icon"></ion-icon>
									</div>
									
									<ion-label class="ml-4">{{ route.name }}</ion-label>
								</a>
							}
						</li>
					}

					<!-- Logout option integrated in the list for better mobile accessibility -->
					<li class="pt-6 mt-6 border-t border-gray-100 pb-[calc(env(safe-area-inset-bottom)+2rem)]">
						<a (click)="logOut()"
							class="flex items-center cursor-pointer p-3 text-lg font-bold text-red-500 tracking-tight transition-all rounded-md hover:bg-red-50 group">
							<div class="w-10 h-10 bg-red-50 rounded-md flex items-center justify-center text-red-500 shadow-sm border border-red-100 group-hover:bg-red-500 group-hover:text-white group-hover:border-transparent transition-all duration-300">
								<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
								</svg>
							</div>
							<span class="ml-4">
								Cerrar Sesión
							</span>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</aside>
